<template lang="pug">
  main
    NavBarInventario
    ModalDelete(v-show="modalStatusDel" :title="titleModalDel" :content="contentModalDel" @padre:eliminar="reingresarItem")
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    ModalYN(v-show="modalStatusYN" :config="configModal" @padre:close="reingresarItem")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading && !ocultarFormAltas")
      .container
        .columns
          .column.is-12.has-text-centered
            h3.title 
              | Salida {{ salida_detalle.id_salida }}
              | &nbsp
              a.button.is-black.is-rounded.is-small(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-4
            .field
              label.label Selecciona el Área
                .control
                  input#area_Inst.is-checkradio(type='radio' v-model="area" value="1" name='sel_area' checked='checked' :disabled="isDisabled")
                  label.is-size-6(for='area_Inst') Instrum.
                  input#area_Sist.is-checkradio(type='radio' v-model="area" value="3" name='sel_area' :disabled="isDisabled")
                  label.is-size-6(for='area_Sist') Sist./Telec.
                  input#area_Adm.is-checkradio(type='radio' v-model="area" value="2" name='sel_area' :disabled="isDisabled")
                  label.is-size-6(for='area_Adm') Admón.
            .field
              label.label Destino
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="ubicacionSel" :disabled="isDisabled")
                    option(value="" checked) Seleccione una Ubicación
                    option(v-for="ubi in ubicaciones" :key="ubi.valor" :value="ubi.valor") {{ ubi.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-map-pin
            .field
              label.label Oficina
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="oficinaSelected" :disabled="isDisabled")
                    option(v-for="data in oficinasSel" :value="data" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-tools
            .field
              label.label Traslada
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="userTraslada" :disabled="isDisabled")
                    option(value="" checked) Seleccione un Usuario
                    option(v-for="data in usuarios" :value="data" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-user-tag
            .field
              label.label Recibe
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="userRecibe" :disabled="isDisabled")
                    option(value="" checked) Seleccione un Usuario
                    option(v-for="data in usuarios" :value="data" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-user-tag
            .field
              a.button.is-warning.is-rounded.is-medium(@click="editSalida" v-show="!isEditing && puedeEditar") Editar
              | &nbsp
              a.button.is-default.is-rounded.is-medium(@click="cancelEditSalida" v-show="isEditing") Cancelar
              | &nbsp
              a.button.is-primary.is-rounded.is-medium(@click="updateSalida" v-show="isEditing") Actualizar
              | &nbsp
              a.button.is-danger.is-rounded.is-medium(@click="printSalida" v-show="!isEditing")
                i.fas.fa-print
          .column.is-8
            ListArticulosSalida(:articulos="articulos" :puedeEditar="puedeEditar" @backItem="backItem"  v-show="articulos.length > 0")
            .notification.is-danger(v-show="articulos.length == 0")
              | No existen Registros.

</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import usuariosServices from '../../services/usuarios/usuarios'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import ModalDelete from '@/components/shared/ModalDelete.vue'
import ModalYN from '@/components/shared/ModalYN.vue'
import AutocompleteArticulos from '@/components/inventario_Componentes/AutocompleteArticulos.vue'
import CardArticulo from '@/components/inventario_Componentes/CardArticulo.vue'
import CarritoSalida from '@/components/inventario_Componentes/CarritoSalida.vue'
import ListaArticulosSalida from '@/components/inventario_Componentes/ListaArticulosSalida.vue'
import ListArticulosSalida from '@/components/inventario_Componentes/ListArticulosSalida.vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'SalidaDetalle',
  components: { Loader, NavBarInventario, HeaderInventario, ModalInfo, AutocompleteArticulos, ListaArticulosSalida, ModalDelete, CardArticulo, CarritoSalida, ListArticulosSalida, ModalYN },
  data () {
    return {
      isLoading: true,
      id: '',
      fecha: '',
      area: '',
      origen: '',
      salidaAutocomplete: {},
      cardDisabled: true,
      usuarios_Recibe: [],
      usuarios_Traslada: [],
      usuarios_Autoriza: [],
      articulos: [],
      articulosSelect: [],
      isDisabled: true,
      isEditing: false,
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      modalStatusDel: false,
      contentModalDel: '',
      titleModalDel: '',
      ocultarFormAltas: false,
      idSalida: '',
      actualizarList: false,
      actualizarAutoComplete: false,
      itemToDelete: {},
      itemToEdit: {},
      isAddingArt: false,
      verListaCarrito: false,
      hayArticulos: true,
      ubicaciones: [
        { nombre: 'TPA', valor: 'TPA' },
        { nombre: 'CORPORATIVO', valor: 'CORP' },
        { nombre: 'EB04', valor: 'EB04' },
        { nombre: 'OTRO', valor: 'OTRO' }
      ],
      allOficinas: [
        { 'id': 'TPA-ALM', 'nombre': 'Almacén', 'source': 'TPA' },
        { 'id': 'TPA-ALS', 'nombre': 'Almacén Sist.', 'source': 'TPA' },
        { 'id': 'TPA-ADM', 'nombre': 'Of. Admin.', 'source': 'TPA' },
        { 'id': 'TPA-CC', 'nombre': 'Cuarto de Control', 'source': 'TPA' },
        { 'id': 'TPA-SERV', 'nombre': 'Servidores', 'source': 'TPA' },
        { 'id': 'TPA-IO', 'nombre': 'Cuarto de IOS', 'source': 'TPA' },
        { 'id': 'TPA-FAC', 'nombre': 'Facturación', 'source': 'TPA' },
        { 'id': 'TPA-BAS', 'nombre': 'Báscula', 'source': 'TPA' },
        { 'id': 'TPA-GER', 'nombre': 'Gerencia', 'source': 'TPA' },
        { 'id': 'TPA-MUE', 'nombre': 'Muelle', 'source': 'TPA' },
        { 'id': 'TPA-MANT', 'nombre': 'Subgerencia de Mntto.', 'source': 'TPA' },
        { 'id': 'TPA-TALL', 'nombre': 'Taller de Mntto.', 'source': 'TPA' },
        { 'id': 'TPA-SEG', 'nombre': 'Subgerencia de Seguridad', 'source': 'TPA' },
        { 'id': 'TPA-SADM', 'nombre': 'Subgerencia Administrativa', 'source': 'TPA' },
        { 'id': 'TPA-PROP', 'nombre': 'Of. Propangol', 'source': 'TPA' },
        { 'id': 'TPA-NIE', 'nombre': 'Of. Nieto', 'source': 'TPA' },
        { 'id': 'TPA-MOV', 'nombre': 'Of. Movenergy', 'source': 'TPA' },
        { 'id': 'TPA-SJ', 'nombre': 'Sala de Juntas', 'source': 'TPA' },
        { 'id': 'TPA-ACC', 'nombre': 'Accesos', 'source': 'TPA' },
        { 'id': 'TPA-VIG', 'nombre': 'Vigilancia', 'source': 'TPA' },
        { 'id': 'TPA-ESF', 'nombre': 'Esféricos', 'source': 'TPA' },
        { 'id': 'TPA-LLEN', 'nombre': 'Llenaderas', 'source': 'TPA' },
        { 'id': 'TPA-SJ2', 'nombre': 'Sala de Juntas 2', 'source': 'TPA' },
        { 'id': 'TPA-REC', 'nombre': 'Recepción', 'source': 'TPA' },
        { 'id': 'TPA-COM', 'nombre': 'Comedor', 'source': 'TPA' },
        { 'id': 'TPA-SALM', 'nombre': 'SubAlmacén', 'source': 'TPA' },
        { 'id': 'TPA-TRE', 'nombre': 'Área 300', 'source': 'TPA' },
        { 'id': 'IRGE-ALM', 'nombre': 'Almacén', 'source': 'IRGE' },
        { 'id': 'IRGE-ADM', 'nombre': 'Of. Admin.', 'source': 'IRGE' },
        { 'id': 'IRGE-CC', 'nombre': 'Cuarto de Control', 'source': 'IRGE' },
        { 'id': 'IRGE-FAC', 'nombre': 'Facturación', 'source': 'IRGE' },
        { 'id': 'IRGE-BAS', 'nombre': 'Báscula', 'source': 'IRGE' },
        { 'id': 'IRGE-GER', 'nombre': 'Gerencia', 'source': 'IRGE' },
        { 'id': 'IRGE-GADM', 'nombre': 'Gerencia Admn.', 'source': 'IRGE' },
        { 'id': 'IRGE-SJ', 'nombre': 'Sala de Juntas', 'source': 'IRGE' },
        { 'id': 'IRGE-SEG', 'nombre': 'Of. Seguridad', 'source': 'IRGE' },
        { 'id': 'IRGE-IOS', 'nombre': 'Cuarto de IOS', 'source': 'IRGE' },
        { 'id': 'IRGE-PEM', 'nombre': 'Of. Pemex', 'source': 'IRGE' },
        { 'id': 'IRGE-ACC', 'nombre': 'Accesos', 'source': 'IRGE' },
        { 'id': 'IRGE-VIG', 'nombre': 'Vigilancia', 'source': 'IRGE' },
        { 'id': 'IRGE-CE', 'nombre': 'Cuarto Eléctrico', 'source': 'IRGE' },
        { 'id': 'IRGE-REC', 'nombre': 'Recepción', 'source': 'IRGE' },
        { 'id': 'IRGE-OP', 'nombre': 'Operación', 'source': 'IRGE' },
        { 'id': 'IRGE-CCP', 'nombre': 'Cuarto Control Plus', 'source': 'IRGE' },
        { 'id': 'IRGE-VP', 'nombre': '23 Puntos', 'source': 'IRGE' },
        { 'id': 'IRGE-MOV', 'nombre': 'Movenergy', 'source': 'IRGE' },
        { 'id': 'IRGE-VIC', 'nombre': 'Vigilanca CUSAEM', 'source': 'IRGE' },
        { 'id': 'IRGE-OFE', 'nombre': 'Oficina Eléctrica', 'source': 'IRGE' },
        { 'id': 'EB04-ALG', 'nombre': 'Almacén S & I', 'source': 'EB04' },
        { 'id': 'EB04-CC', 'nombre': 'Cuarto de Control', 'source': 'EB04' },
        { 'id': 'EB04-ADM', 'nombre': 'Of. Admin.', 'source': 'EB04' },
        { 'id': 'EB04-GER', 'nombre': 'Gerencia', 'source': 'EB04' },
        { 'id': 'EB04-SIS', 'nombre': 'Sistemas', 'source': 'EB04' },
        { 'id': 'EB04-INS', 'nombre': 'Instrumentación', 'source': 'EB04' },
        { 'id': 'EB04-VIG', 'nombre': 'Vigilancia', 'source': 'EB04' },
        { 'id': 'EB04-SG', 'nombre': 'Sala de Juntas', 'source': 'EB04' },
        { 'id': 'EB04-TIA', 'nombre': 'Taller Inst/Aut', 'source': 'EB04' },
        { 'id': 'EB04-ALM', 'nombre': 'Almacén', 'source': 'EB04' },
        { 'id': 'EB03-CC', 'nombre': 'Cuarto de Control', 'source': 'EB03' },
        { 'id': 'EB03-ADM', 'nombre': 'Of. Admin.', 'source': 'EB03' },
        { 'id': 'EB03-VIG', 'nombre': 'Vigilancia', 'source': 'EB03' },
        { 'id': 'EB03-ARC', 'nombre': 'Archivo', 'source': 'EB03' },
        { 'id': 'EB03-COM', 'nombre': 'Comedor', 'source': 'EB03' },
        { 'id': 'EB03-REC', 'nombre': 'Recepción', 'source': 'EB03' },
        { 'id': 'EB03-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB03' },
        { 'id': 'EB03-SV', 'nombre': 'Servicios', 'source': 'EB03' },
        { 'id': 'EB03-TAL', 'nombre': 'Taller', 'source': 'EB03' },
        { 'id': 'EB03-ALM', 'nombre': 'Almacén', 'source': 'EB03' },
        { 'id': 'EB02-CC', 'nombre': 'Cuarto de Control', 'source': 'EB02' },
        { 'id': 'EB02-ADM', 'nombre': 'Of. Admin.', 'source': 'EB02' },
        { 'id': 'EB02-VIG', 'nombre': 'Vigilancia', 'source': 'EB02' },
        { 'id': 'EB02-ARC', 'nombre': 'Archivo', 'source': 'EB02' },
        { 'id': 'EB02-COM', 'nombre': 'Comedor', 'source': 'EB02' },
        { 'id': 'EB02-REC', 'nombre': 'Recepción', 'source': 'EB02' },
        { 'id': 'EB02-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB02' },
        { 'id': 'EB02-ALM', 'nombre': 'Almacén', 'source': 'EB02' },
        { 'id': 'EB01-CC', 'nombre': 'Cuarto de Control', 'source': 'EB01' },
        { 'id': 'EB01-ADM', 'nombre': 'Of. Admin.', 'source': 'EB01' },
        { 'id': 'EB01-VIG', 'nombre': 'Vigilancia', 'source': 'EB01' },
        { 'id': 'EB01-ARC', 'nombre': 'Archivo', 'source': 'EB01' },
        { 'id': 'EB01-COM', 'nombre': 'Comedor', 'source': 'EB01' },
        { 'id': 'EB01-REC', 'nombre': 'Recepción', 'source': 'EB01' },
        { 'id': 'EB01-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB01' },
        { 'id': 'EB01-ALM', 'nombre': 'Almacén', 'source': 'EB01' },
        { 'id': 'EB00-CC', 'nombre': 'Cuarto de Control', 'source': 'EB00' },
        { 'id': 'EB00-ADM', 'nombre': 'Of. Admin.', 'source': 'EB00' },
        { 'id': 'EB00-VIG', 'nombre': 'Vigilancia', 'source': 'EB00' },
        { 'id': 'EB00-ALM', 'nombre': 'Almacén', 'source': 'EB00' },
        { 'id': 'EB00-ARC', 'nombre': 'Archivo', 'source': 'EB00' },
        { 'id': 'EB00-COM', 'nombre': 'Comedor', 'source': 'EB00' },
        { 'id': 'EB00-SV', 'nombre': 'Servicios', 'source': 'EB00' },
        { 'id': 'ERM-CC', 'nombre': 'Cuarto de Control', 'source': 'ERM' },
        { 'id': 'ERM-ADM', 'nombre': 'Of. Admin.', 'source': 'ERM' },
        { 'id': 'ERM-VIG', 'nombre': 'Vigilancia', 'source': 'ERM' },
        { 'id': 'ERM-ALM', 'nombre': 'Almacén', 'source': 'ERM' },
        { 'id': 'VALV-ADM', 'nombre': 'Gabinete', 'source': 'LPGD' },
        { 'id': 'CORP-DIR', 'nombre': 'Dirección', 'source': 'CORP' },
        { 'id': 'CORP-GG', 'nombre': 'Gerencia Gral.', 'source': 'CORP' },
        { 'id': 'CORP-GC', 'nombre': 'Gerencia de Contraloría', 'source': 'CORP' },
        { 'id': 'CORP-C', 'nombre': 'Contabilidad', 'source': 'CORP' },
        { 'id': 'CORP-CP', 'nombre': 'Cuentas por Pagar', 'source': 'CORP' },
        { 'id': 'CORP-F', 'nombre': 'Fiscal', 'source': 'CORP' },
        { 'id': 'CORP-SA', 'nombre': 'Seguimiento Amb.', 'source': 'CORP' },
        { 'id': 'CORP-GR', 'nombre': 'Gerencia de Reg.', 'source': 'CORP' },
        { 'id': 'CORP-ALM', 'nombre': 'Almacén', 'source': 'CORP' },
        { 'id': 'CORP-ALG', 'nombre': 'Almacén GIA', 'source': 'CORP' },
        { 'id': 'CORP-GIS', 'nombre': 'Gerencia Inst. y Sist.', 'source': 'CORP' },
        { 'id': 'CORP-SIT', 'nombre': 'Site', 'source': 'CORP' },
        { 'id': 'CORP-RH', 'nombre': 'Recursos Humanos', 'source': 'CORP' },
        { 'id': 'CORP-LEG', 'nombre': 'Legal', 'source': 'CORP' },
        { 'id': 'CORP-REC', 'nombre': 'Recepción', 'source': 'CORP' },
        { 'id': 'CORP-AUD', 'nombre': 'Auditoría', 'source': 'CORP' },
        { 'id': 'CORP-TES', 'nombre': 'Tesorería', 'source': 'CORP' },
        { 'id': 'CORP-GEN', 'nombre': 'General', 'source': 'CORP' },
        { 'id': 'LPGD-V1', 'nombre': 'Válvula 1', 'source': 'LPGD' },
        { 'id': 'LPGD-V2', 'nombre': 'Válvula 2', 'source': 'LPGD' },
        { 'id': 'LPGD-V3', 'nombre': 'Válvula 3', 'source': 'LPGD' },
        { 'id': 'LPGD-V4', 'nombre': 'Válvula 4', 'source': 'LPGD' },
        { 'id': 'LPGD-V5', 'nombre': 'Válvula 5', 'source': 'LPGD' },
        { 'id': 'LPGD-V6', 'nombre': 'Válvula 6', 'source': 'LPGD' },
        { 'id': 'LPGD-V7', 'nombre': 'Válvula 7', 'source': 'LPGD' },
        { 'id': 'LPGD-V8', 'nombre': 'Válvula 8', 'source': 'LPGD' },
        { 'id': 'LPGD-V9', 'nombre': 'Válvula 9', 'source': 'LPGD' },
        { 'id': 'LPGD-V10', 'nombre': 'Válvula 10', 'source': 'LPGD' },
        { 'id': 'LPGD-V11', 'nombre': 'Válvula 11', 'source': 'LPGD' },
        { 'id': 'LPGD-V12', 'nombre': 'Válvula 12', 'source': 'LPGD' },
        { 'id': 'LPGD-V13', 'nombre': 'Válvula 13', 'source': 'LPGD' },
        { 'id': 'LPGD-V14', 'nombre': 'Válvula 14', 'source': 'LPGD' },
        { 'id': 'LPGD-V15', 'nombre': 'Válvula 15', 'source': 'LPGD' },
        { 'id': 'LPGD-V16', 'nombre': 'Válvula 16', 'source': 'LPGD' },
        { 'id': 'LPGD-V17', 'nombre': 'Válvula 17', 'source': 'LPGD' },
        { 'id': 'LPGD-V18', 'nombre': 'Válvula 18', 'source': 'LPGD' },
        { 'id': 'LPGD-V19', 'nombre': 'Válvula 19', 'source': 'LPGD' },
        { 'id': 'LPGD-V20', 'nombre': 'Válvula 20', 'source': 'LPGD' },
        { 'id': 'LPGD-V21', 'nombre': 'Válvula 21', 'source': 'LPGD' },
        { 'id': 'LPGD-V22', 'nombre': 'Válvula 22', 'source': 'LPGD' },
        { 'id': 'LPGD-V23', 'nombre': 'Válvula 23', 'source': 'LPGD' },
        { 'id': 'LPGD-V24', 'nombre': 'Válvula 24', 'source': 'LPGD' },
        { 'id': 'LPGD-V25', 'nombre': 'Válvula 25', 'source': 'LPGD' },
        { 'id': 'LPGD-V26', 'nombre': 'Válvula 26', 'source': 'LPGD' },
        { 'id': 'LPGD-V1B', 'nombre': 'Válvula 1 BIS', 'source': 'LPGD' },
        { 'id': 'LPGD-V2B', 'nombre': 'Válvula 2 BIS', 'source': 'LPGD' },
        { 'id': 'LPGD-V3B', 'nombre': 'Válvula 3 BIS', 'source': 'LPGD' },
        { 'id': 'LPGD-V4B', 'nombre': 'Válvula 4 BIS', 'source': 'LPGD' },
        { 'id': 'LPGD-V5B', 'nombre': 'Válvula 5 BIS', 'source': 'LPGD' },
        { 'id': 'LPGD-INT', 'nombre': 'Interconexión', 'source': 'LPGD' },
        { 'id': 'TPA-RV', 'nombre': 'Recuperador de vapores', 'source': 'TPA'},
        { 'id': 'TPA-PM', 'nombre': 'Paquete de Medición', 'source': 'TPA'},
        { 'id': 'TPA-BP', 'nombre': 'Bombas de Proceso', 'source': 'TPA'},
        { 'id': 'TPA-SISV', 'nombre': 'Sistema Vickers', 'source': 'TPA'},
        { 'id': 'TPA-SCI', 'nombre': 'Sist. Contra Incendio', 'source': 'TPA'},
        { 'id': 'TPA-CB', 'nombre': 'Cuarto de Baterias', 'source': 'TPA'},
        { 'id': 'EB00-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB00'},
        { 'id': 'EB00-CB', 'nombre': 'Cuarto de Baterias', 'source': 'EB00'},
        { 'id': 'EB00-PM', 'nombre': 'Patín de Medición', 'source': 'EB00'},
        { 'id': 'EB00-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB00'},
        { 'id': 'EB00-TR', 'nombre': 'Tren de Regulación', 'source': 'EB00'},
        { 'id': 'ERM-PM', 'nombre': 'Patín de Medición', 'source': 'ERM'},
        { 'id': 'ERM-SAL', 'nombre': 'Salida IRGE', 'source': 'ERM'},
        { 'id': 'ERM-TD', 'nombre': 'Trampa de Diablos', 'source': 'ERM'},
        { 'id': 'ERM-TP', 'nombre': 'Tanque Pulmón', 'source': 'ERM'},
        { 'id': 'ERM-TPRG', 'nombre': 'Tanque de Purga', 'source': 'ERM'},
        { 'id': 'ERM-TR', 'nombre': 'Tren de Regulación', 'source': 'ERM'},
        { 'id': 'ERM-JEF', 'nombre': 'Jefatura', 'source': 'ERM'},
        { 'id': 'ERM-COM', 'nombre': 'Comedor', 'source': 'ERM'},
        { 'id': 'ERM-CEL', 'nombre': 'Cuarto Eléctrico', 'source': 'ERM'},
        { 'id': 'EB04-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB04'},
        { 'id': 'EB04-CAB', 'nombre': 'Cabezales', 'source': 'EB04'},
        { 'id': 'EB04-CB', 'nombre': 'Cobertizo de Bombas', 'source': 'EB04'},
        { 'id': 'EB04-COC', 'nombre': 'Cocina', 'source': 'EB04'},
        { 'id': 'EB04-CTE', 'nombre': 'Cuarto Eléctrico', 'source': 'EB04'},
        { 'id': 'EB04-GEN', 'nombre': 'Generadores', 'source': 'EB04'},
        { 'id': 'EB04-PM', 'nombre': 'Patín de Medición', 'source': 'EB04'},
        { 'id': 'EB04-RP', 'nombre': 'Residuos Peligrosos', 'source': 'EB04'},
        { 'id': 'EB04-TALL', 'nombre': 'Taller y Almacén', 'source': 'EB04'},
        { 'id': 'EB04-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB04'},
        { 'id': 'EB04-TORG', 'nombre': 'Tanque de Purga', 'source': 'EB04'},
        { 'id': 'EB04-TR', 'nombre': 'Tren de Regulación', 'source': 'EB04'},
        { 'id': 'EB04-TRA', 'nombre': 'Transformador', 'source': 'EB04'},
        { 'id': 'IRGE-BOM', 'nombre': 'Bombas LPG', 'source': 'IRGE'},
        { 'id': 'IRGE-BP', 'nombre': 'Bombas de Proceso', 'source': 'IRGE'},
        { 'id': 'IRGE-CB', 'nombre': 'Cuarto de Bombas', 'source': 'IRGE'},
        { 'id': 'IRGE-CCM', 'nombre': 'CCM', 'source': 'IRGE'},
        { 'id': 'IRGE-CI', 'nombre': 'Red C.I.', 'source': 'IRGE'},
        { 'id': 'IRGE-COMP', 'nombre': 'Area de Compresores', 'source': 'IRGE'},
        { 'id': 'IRGE-CONT', 'nombre': 'Contabilidad', 'source': 'IRGE'},
        { 'id': 'IRGE-CUB', 'nombre': 'Cubeta', 'source': 'IRGE'},
        { 'id': 'IRGE-ESF', 'nombre': 'Esferas', 'source': 'IRGE'},
        { 'id': 'IRGE-LLEN', 'nombre': 'Llenaderas', 'source': 'IRGE'},
        { 'id': 'IRGE-MANT', 'nombre': 'Of. Mantenimiento', 'source': 'IRGE'},
        { 'id': 'IRGE-PROP', 'nombre': 'Of. Propangol', 'source': 'IRGE'},
        { 'id': 'IRGE-TA', 'nombre': 'Tanque de Agua', 'source': 'IRGE'},
        { 'id': 'IRGE-TD', 'nombre': 'Trampa de Diablos', 'source': 'IRGE'},
        { 'id': 'IRGE-TP', 'nombre': 'Tanque Pulmón', 'source': 'IRGE'},
        { 'id': 'IRGE-TR', 'nombre': 'Tren de Regulación', 'source': 'IRGE'},
        { 'id': 'IRGE-TRA', 'nombre': 'Area de Trasiegos', 'source': 'IRGE'},
        { 'id': 'IRGE-TALL', 'nombre': 'Taller', 'source': 'IRGE'},
      ],
      oficinasSel: [],
      oficinaSelected: null,
      oficinas: [
        { 'id': 'TPA-ALS', 'nombre': 'Almacén Sist.', 'source': 'TPA' },
        { 'id': 'EB04-ALG', 'nombre': 'Almacén S & I', 'source': 'EB04' },
        { 'id': 'CORP-ALG', 'nombre': 'Almacén GIA', 'source': 'CORP' }
      ],
      ubicacionSel: null,
      userRecibe: {},
      userTraslada: {},
      userAutoriza: {},
      usuarios: [],
      configModal: {},
      itemToBack: {},
      modalStatusYN: false,
      puedeEditar: false,
    }
  },
  watch: {
    ubicacionSel() {
      if (this.ubicacionSel === 'OTRO') { 
        this.oficinasSel = this.allOficinas
      } else {
        this.oficinasSel = this.oficinas.filter( ofi => ofi.source === this.ubicacionSel)
      }
    },
    area() {
      console.log(this.area)
      let objAutoriza = {}
      switch (parseInt(this.area)) {
        case 1:
          objAutoriza = this.usuarios_Autoriza.find( u => u.cargo === '210' )  
          break
        case 2:
          objAutoriza = this.usuarios_Autoriza.find( u => u.cargo === '002' )  
          break
        case 3:
          objAutoriza = this.usuarios_Autoriza.find( u => u.cargo === '230' )  
          break
      
        default:
          break
      }
      console.log(objAutoriza)
      this.idAutoriza = objAutoriza.id
      this.autoriza = objAutoriza.nombre
    }
  },
  methods: {
    obtenerDatosSalida () {
      this.userRecibe = this.usuarios.find((user) => user.id === this.salida_detalle.id_recibe)
      this.userTraslada = this.usuarios.find((user) => user.id === this.salida_detalle.id_traslada)
      this.userAutoriza = this.usuarios.find((user) => user.id === this.salida_detalle.id_autoriza)

      switch (this.salida_detalle.oficina) {
        case 'TPA-ALS':
          this.ubicacionSel = this.salida_detalle.destino    
          break
        case 'EB04-ALG':
          this.ubicacionSel = this.salida_detalle.destino
          break
        case 'CORP-ALG':
          this.ubicacionSel = this.salida_detalle.destino
          break
          
        default:
          this.ubicacionSel = this.ubicaciones.find( ubi => ubi.nombre === 'OTRO')
          break
      }
      
      
      this.id = this.salida_detalle.id
      this.fecha = this.salida_detalle.fechaReg
      this.area = this.salida_detalle.area
      this.origen = this.salida_detalle.origen
      this.area = this.salida_detalle.area
      
      this.obtenerArticulos()
              
    },

    obtenerArticulos () {
      InventarioServices.getItemsSalida(this.salida_detalle.id_salida)
        .then(data => {
          console.log(data)
          this.articulos = data
          let numArts = this.articulos.length
          console.log(numArts)
          this.articulosSelect = this.articulos
          if (numArts == 0) {
            this.hayArticulos = false
          } else {
            this.hayArticulos = true
          }
          this.isLoading = false
          console.log(this.oficinasSel)
          this.oficinaSelected = this.oficinasSel.find(ofi => ofi.id ===  this.salida_detalle.oficina)
        })
    },

    obtenerUsuarios () {
      usuariosServices.getUsuarios()
        .then(res => {
          console.log(res)
          if (res.length > 0) {
              this.usuarios = res.filter(user => user.id !== '1538165924968' && user.id !== '1565972235101' && user.id !== '1556122430935' && user.id !== '1539965959482' && parseInt(user.categoria) < 5)
              let uRecibe = this.usuarios
              let uAutoriza = this.usuarios.filter(user => user.categoria === '2' || user.categoria === '1')
              let uTraslada = this.usuarios
              this.usuarios_Autoriza = uAutoriza
              this.usuarios_Recibe = uRecibe
              this.usuarios_Traslada = uTraslada
              this.obtenerDatosSalida()
            } else {
              this.titleModal = 'Error'
              this.contentModal = res.respuesta
              this.modalStatus = true
            }
        })
    },

    updateSalida () {
      this.isEditing = false
      this.isDisabled = true
      this.isLoading = true      

      InventarioServices.editSalida(this.salida_detalle.id_salida, this.userTraslada.id, this.userTraslada.nombre, this.userRecibe.id, this.userRecibe.nombre, this.userAutoriza.id, this.userAutoriza.nombre, this.ubicacionSel, this.oficinaSelected.id, this.area)
        .then(res => {
          if (res.success) {

            this.articulosSelect.forEach(art => {
              InventarioServices.updateArticulo_ubi_salida(art.id_ubiArt, this.ubicacionSel, this.oficinaSelected.id, this.userRecibe.id, this.userRecibe.usuario)
                .then((data) => {
                  if (data.success) {
                    this.displayToast(data.respuesta, 'done', 'OK')
                  } else {
                    this.displayToast(data.respuesta, 'ban', 'OK')
                  }
                })
                .catch((e) => {
                  this.isLoading = false
                  this.console.error(`Error: ${e.message}`)
                })
            })

              this.isEditing = false
              this.isDisabled = true  
              this.isLoading = false
              this.displayToast('Se actualizó la salida correctamente.', 'done', 'Ok')
            

          } else {
            this.isLoading = false
            this.displayToast(`Error: ${res.respuesta}`, 'ban', 'Ok')
          }
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast(e.message, 'ban', 'OK')
        })
    },

    editSalida () {
      this.isDisabled = false
      this.isEditing = true
      this.cardDisabled = false
    },

    cancelEditSalida () {
      this.isDisabled = true
      this.isEditing = false
      this.cardDisabled = true
    },

    addArt () {
      this.isAddingArt = true
      this.salidaAutocomplete = this.salida_detalle
      this.$store.commit('actComp_Autocomplete', true)
    },

    closeAddItem () {
      this.isAddingArt = false
      this.$store.commit('actComp_Autocomplete', false)
    },

    cerrarModal () {
      this.modalStatus = false
    },

    cerrarAutocomplete () {
      this.closeAddItem()
    },

    eliminarItem (item) {
      console.log(item)
      if (item) {
        this.itemToDelete = item
        this.titleModalDel = 'Eliminar.'
        this.contentModalDel = `¿Seguro desea eliminar ${item.serie}?`
        this.modalStatusDel = true
      }
    },

    editarItem (item) {
      console.log(item)
      if (item) {
        this.itemToEdit = item
        this.isAddingArt = true
      }
    },

    deleteItem (result) {
      console.log(result)
      this.modalStatusDel = false
      if (result === 'delete') { 
        this.isLoading = true
        InventarioServices.deleteItemToSalida(this.itemToDelete.id)
          .then(data => {
            console.log(data)
            this.isLoading = true
            if (data.success){

              InventarioServices.deleteRegUbicacion(this.itemToDelete.id_articulo, this.itemToDelete.ubicacion, '1')
                .then(dataReg => {
                  console.log(dataReg)
                  if (dataReg.success) {
                    
                    InventarioServices.getUltimoMov(this.itemToDelete.id_articulo)
                      .then (ult => {
                        console.log(ult)
                        if (ult.success) {

                        }
                      })
                      .catch(e=> console.log(e))

                  } else {
                    setTimeout(() => {
                      this.titleModal = 'Error.'
                      this.contentModal = dataReg.respuesta
                      this.modalStatus = true
                      this.isLoading = false
                    }, 250)
                  }
                })

              InventarioServices.updateUbicacionArt(this.itemToDelete.id_articulo,this.origen, this.idEntrega, this.entrega)
                .then(dataUbi => {
                  console.log(dataUbi)
                  if (dataUbi.success) {

                    
                  } else {
                    setTimeout(() => {
                      this.titleModal = 'Error.'
                      this.contentModal = dataUbi.respuesta
                      this.modalStatus = true
                      this.isLoading = false
                    }, 250)
                  }

                })
                  
            } else {
              setTimeout(() => {
                this.titleModal = 'Error.'
                this.contentModal = data.respuesta
                this.modalStatus = true
                this.isLoading = false
              }, 250)
            }
          })
      } else {

      }
    },

    finalizarEdicion (finalizar) {
      if (finalizar) {
        this.itemToEdit = {}
      } 
    },

    listadoActualizado (result) {
      this.actualizarList = false
      setTimeout(() => {
        this.actualizarAutoComplete = true
      }, 250)
    },

    printSalida () {
      let currentUrl = window.location.hostname
      let link
      console.log(currentUrl)
      
      link = `https://${currentUrl}/servidores/reportes/inventarios/salidaI.php?id=${this.salida_detalle.id_salida}`
      console.log(link)
      
      if (open(link)) {
        console.log('Abriendo archivo')
      }
    },

    mostrarListaCarrito (result) {
      this.verListaCarrito = result
    },

    agregarItems_Carrito (art){
      this.$store('agregarArticulos_Salida', art)
    },

    backPage () {
      this.$store.commit('limpiarArticulos_Salida')
      this.$router.back()
    },
    displayToast(text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    backItem (art) {
      this.configModal = {
        title: 'Reingresar Item',
        content: '¿Desea reingresar el item al almacén?',
        textCancel: 'Cancelar',
        textOk: 'Reingresar'
      }
      this.itemToBack = art
      this.modalStatusYN = true
    },
    reingresarItem (resp) {
      console.log(resp)
      if (resp) {
        
        let idMov = Date.now()
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        let almacen = ''
        let idRec= ''
        let rec = ''

        switch (this.userLogin.ubicacion) {
          case 'TPA':
            idRec = '1565899419222'
            rec = 'TPA'
            if (this.userLogin.cargo === "321") {
              almacen = 'TPA-ALM'
            } else {
              almacen = 'TPA-ALS'
            }
            break
          case 'EB04':
            almacen = 'EB04-ALG'
            idRec = '1566322725551'
            rec = 'EB04'
            break
          case 'CORPORATIVO':
            idRec = '1588283398540'
            rec = 'CORPO'
            if (this.userLogin.cargo === "323" || this.userLogin.cargo ==='324') {
              almacen = 'CORP-ALM'
            } else {
              almacen = 'CORP-ALG'
            }
            break

          case 'IRGE':
            almacen = 'IRGE-ALM'
            idRec = '1566247215482'
            rec = 'IRGE'
            break
        
          default:
            almacen = ''
            idRec = ''
            rec = ''
            break
        }
        const ubi = this.userLogin.ubicacion === 'CORPORATIVO' ? 'CORP' : this.userLogin.ubicacion
        InventarioServices.addUbicacion(idMov, this.itemToBack.id, fechaReg,  ubi, almacen, this.itemToBack.idResguardo, this.itemToBack.resguardo, idRec, rec, 6)
          .then((data) => {
            console.log(data)
            if (data.success) {
              this.displayToast(`El item ha sido regresado al almacén ${almacen}.`, 'done', 'Ok')
              this.backPage()
            } else {
              this.displayToast(data.respuesta, 'ban', 'Ok')
            }
          })
          .catch((e) => this.displayToast(e.message,'ban','Ok'))


      } else {
        this.itemToBack = {}
      }
      this.modalStatusYN = false
    },
  },
  created () {
    if (this.userLogin.id === this.salida_detalle.id_entrega) {
      this.puedeEditar = true
    }
    this.obtenerUsuarios()
  },
  computed: {
    ...mapState(['userLogin', 'salida_detalle'])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/SalidaDetalle.vue